import { axInst } from "../Login/Service.jsx";

//region
export const fetchRegion = async () => {
  const { data } = await axInst.post("dealer-review/dealer_review_filter", {
    region: [],
    state: [],
    state_office: [],
    dealer_name: [],
    dealer_code: [],
    Product_Line: [],
    lob: [],
    Partner_Type: [],
  });

  const regionsArray = data?.REGION.buckets.map((e) => e.key);
  const sortedRegionArray = regionsArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true }),
  );
  return sortedRegionArray;
};

//state
export const fetchStates = async (pRegion) => {
  const { data } = await axInst.post("dealer-review/dealer_review_filter", {
    region: pRegion || [],
    state: [],
    state_office: [],
    dealer_name: [],
    dealer_code: [],
    Product_Line: [],
    lob: [],
    Partner_Type: [],
  });
  const statesArray = data?.STATE.buckets.map((e) => e.key);
  const sortedStatesArray = statesArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true }),
  );

  return sortedStatesArray;
};

//stateoffice
export const fetchStatesOffice = async (pRegion, pState) => {
  const { data } = await axInst.post("dealer-review/dealer_review_filter", {
    region: pRegion || [],
    state: pState || [],
    state_office: [],
    dealer_name: [],
    dealer_code: [],
    Product_Line: [],
    lob: [],
    Partner_Type: [],
  });
  const statesOfficeArray = data?.STATE_OFFICE.buckets.map((e) => e.key);
  const sortedStatesOfficeArray = statesOfficeArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true }),
  );

  return sortedStatesOfficeArray;
};

export const fetchPartnerType = async (pRegion, pState, pStateOffice) => {
  const { data } = await axInst.post("dealer-review/dealer_review_filter", {
    region: pRegion || [],
    state: pState || [],
    state_office: pStateOffice || [],
    Partner_Type: [],
    dealer_name: [],
    dealer_code: [],
    Product_Line: [],
    lob: [],
  });

  const PartnerTypeArray = data?.PARTNER_TYPE.buckets.map((e) => e.key);
  const sortedPartnerTypeArray = PartnerTypeArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true }),
  );

  return sortedPartnerTypeArray;
};

//DealerName
export const fetchDealer = async (
  pRegion,
  pState,
  pStateOffice,
  pPartnerType,
) => {
  const { data } = await axInst.post("dealer-review/dealer_review_filter", {
    region: pRegion || [],
    state: pState || [],
    state_office: pStateOffice || [],
    Partner_Type: pPartnerType || [],
    dealer_name: [],
    dealer_code: [],
    Product_Line: [],
    lob: [],
  });
  const DealerArray = data?.DEALER_NAME.buckets.map((e) => e.key);
  const sortedDealerArray = DealerArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true }),
  );

  return sortedDealerArray;
};

//DealerCode
export const fetchDealercode = async (
  pRegion,
  pState,
  pStateOffice,
  pPartnerType,
  pDealer,
) => {
  const { data } = await axInst.post("dealer-review/dealer_review_filter", {
    region: pRegion || [],
    state: pState || [],
    state_office: pStateOffice || [],
    Partner_Type: pPartnerType || [],
    dealer_name: pDealer || [],
    dealer_code: [],
    Product_Line: [],
    lob: [],
  });
  const dealercodeArray = data?.DEALER_CODE.buckets.map((e) => e.key);
  const sorteddealercodeArray = dealercodeArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true }),
  );

  return sorteddealercodeArray;
};

export const fetchProductLine = async (
  pRegion,
  pState,
  pStateOffice,
  pPartnerType,
  pDealer,
  pDealerCode,
) => {
  const { data } = await axInst.post("dealer-review/dealer_review_filter", {
    region: pRegion || [],
    state: pState || [],
    state_office: pStateOffice || [],
    Partner_Type: pPartnerType || [],
    dealer_name: pDealer || [],
    dealer_code: pDealerCode || [],
    Product_Line: [],
    lob: [],
    Partner_Type: [],
  });
  const productLineArray = data?.PRODUCT_LINE.buckets.map((e) => e.key);

  const sortedProductLineArray = productLineArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true }),
  );
  return sortedProductLineArray;
};

//Lob
export const fetchLOB = async (
  pRegion,
  pState,
  pStateOffice,
  pPartnerType,
  pDealer,
  pDealerCode,
  pProductLine,
) => {
  const { data } = await axInst.post("dealer-review/dealer_review_filter", {
    region: pRegion || [],
    state: pState || [],
    state_office: pStateOffice || [],
    Partner_Type: pPartnerType || [],
    dealer_name: pDealer || [],
    dealer_code: pDealerCode || [],
    Product_Line: pProductLine || [],
    lob: [],
  });

  const lobArray = data?.LOB.buckets.map((e) => e.key);
  const sortedLobArray = lobArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true }),
  );

  return sortedLobArray;
};
